import { render, staticRenderFns } from "./ContestQuestion.vue?vue&type=template&id=07deb1fc&scoped=true&"
import script from "./ContestQuestion.vue?vue&type=script&lang=js&"
export * from "./ContestQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ContestQuestion.vue?vue&type=style&index=0&id=07deb1fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07deb1fc",
  null
  
)

export default component.exports